import script from "./ArchitectureEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchitectureEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ArchitectureEditorDialog.vue?vue&type=style&index=0&id=637cbdf9&lang=css"

const __exports__ = script;

export default __exports__